/***************************************************************************
 * globalAjaxError is a function to deal with error cases globally
 **************************************************************************/
ht.globalAjaxError = function () {
  ht.log('Error', arguments);
};
